// @ts-nocheck
// hack because cannot retrieve full location from react-router
const windowExist = typeof window !== "undefined";
export const windowLocation = () => {
    if (windowExist) {
        return window.location;
    }
};
